export const CLIENT_CAPABILITIES = {
  default: {
    // Maintenance Modules / Functionality
    MAINTENANCE_PAYROLL_ADDITIONS: true,
    MAINTENANCE_PAYROLL_DEDUCTIONS: true,
    MAINTENANCE_PAYROLL_ADJUSTMENTS: true,

    MAINTENANCE_FINALPAY_ADDITIONS: true,
    MAINTENANCE_FINALPAY_DEDUCTIONS: true,
    MAINTENANCE_FINALPAY_ADJUSTMENTS: true,

    ALLOW_FLEXITIME: false,

    POSITION_CODE: false,
    POSITION_LABEL_REGULAR_TITLE: false,
    POSITION_UNIT_CODE: false,
    DEPARTMENT_CODE: false,
    DEPARTMENT_LABEL_UNITDEPARTMENT: false,
    SHIFTSCHEDULE_CODE: false,

    DIVISION_MODULE: false, // use to display the division dropdown
    DISTANTWATER_MODULE: false,
    AREAOFOPERATION_MODULE: false,

    AREAOFOPERATION_CODE: false,
    SUBAREA_CODE: false,
    VESSELFUNCTION_CODE: false,

    TIMEKEEPING_DATFILE_UPLOAD: false,
    TIMEKEEPING_TIMEENTRIES_UPLOAD: true,
    TIMEENTRIES_FIXEDLOGS_CONFIG: true,

    // ERE : Longitude, latitude :: Location rules
    LOCATION_TBL_LONGITUDE: false,
    LOCATION_TBL_LATITUDE: false,

    // RBL : BreakIn, Breakout :: TimeLogs
    TIMEKEEPING_TBL_BREAKIN: false,
    TIMEKEEPING_TBL_BREAKOUT: false,

    // RBL : VESSEL, EmployeeType : Personal Info
    TIMEKEEPING_VESSEL: false,
    TIMEKEEPING_EMPLOYEETYPE: false,


    // Display LateDuction RULE
    PAYROLL_LATEDEDUCTION: false,
    TIMEENTRIES_LATEDEDUCTION: false,
    FINALPAY_LATEDEDUCTION: false,

    EMPLOYEELIST_VESSEL: false,
    EMPLOYEELIST_EMPLOYEETYPE: false,

    EMPLOYEE_PERSONAL_EDITABLEEMPLOYEEID: false,
    EMPLOYEE_ACCOUNT_SEAMAN_BOOK: false,
    EMPLOYEE_ACCOUNT_LICENSE_INFORMATION: false,
    EMPLOYEE_ACCOUNT_EMPLOYEE_BANK_TAXABLE_STAT: false,
    EMPLOYEE_INFORMATION_DESTINATION: false,

    SALARY_TYPE_HAS_QOUTABASE: false,
    EMPLOYEE_DAILY_SALARY_HAS_SALARY_BASIC: false,

    // APPROVER_HIERARCHY
    APPROVER_HIERARCHY__FINANCIAL_APPROVERS: false, // temp disabled, enable when using later
    APPROVER_HIERARCHY__AMOUNT_THRESHOLDS: false,
    APPROVER_HIERARCHY__APPROVAL_POLICIES: false, // setup to modify the Financial/Amount Thresholds
    APPROVER_HIERARCHY__EMPLOYEE_TRANSACTION_APPROVERS: false, // Employee Transaction Approver List management
    // Request_Approval
    REQUEST_APPROVAL__FINANCIAL_REQUESTS: false, // temp disabled, enable when using later
    REQUEST_APPROVAL__EMPLOYEE_TRANSACTION_REQUESTS: false, // temp disabled, enable when using later

    // MODULE ACCESS
    CASH_ADVANCE_MODULE: true,
    SALARY_ADVANCE_MODULE: false,
    EMPLOYEE_TRANSACTION_MODULE: false,

    // OVERTIME
    ALLOW_OT_REQUEST_DATETIME : false,

    // Filters Initial
    EMPLOYEE_FILTERS: ['DEPARTMENT', 'POSITION'],
    PAYROLL_EMPLOYEE_FILTERS: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION'],
    MAINTENANCE_SALARY_FILTERS: ['DEPARTMENT', 'POSITION'],
  },
  ere: {
    LOCATION_TBL_LONGITUDE: true,
    LOCATION_TBL_LATITUDE: true,

    // Filter
    EMPLOYEE_FILTERS: ['CLIENT', 'DEPARTMENT', 'POSITION'],
    PAYROLL_EMPLOYEE_FILTERS: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION'],
  },
  rbl: {
    ALLOW_FLEXITIME: false,
    POSITION_CODE: true,
    POSITION_LABEL_REGULAR_TITLE: true,
    DEPARTMENT_LABEL_UNITDEPARTMENT: true,
    POSITION_UNIT_CODE: true,
    DEPARTMENT_CODE: true,
    SHIFTSCHEDULE_CODE: true,

    DIVISION_MODULE: true,
    DISTANTWATER_MODULE: true,
    AREAOFOPERATION_MODULE: true,

    AREAOFOPERATION_CODE: true,
    SUBAREA_CODE: true,
    VESSELFUNCTION_CODE: true,


    TIMEKEEPING_DATFILE_UPLOAD: true,
    TIMEKEEPING_TIMEENTRIES_UPLOAD: false,
    TIMEENTRIES_FIXEDLOGS_CONFIG: false,

    TIMEKEEPING_TBL_BREAKIN: true,
    TIMEKEEPING_TBL_BREAKOUT: true,

    TIMEKEEPING_VESSEL: true,
    TIMEKEEPING_EMPLOYEETYPE: true,
    EMPLOYEELIST_VESSEL: true,
    EMPLOYEELIST_EMPLOYEETYPE: true,

    EMPLOYEE_ACCOUNT_SEAMAN_BOOK: true,
    EMPLOYEE_ACCOUNT_LICENSE_INFORMATION: true,
    EMPLOYEE_ACCOUNT_EMPLOYEE_BANK_TAXABLE_STAT: true,
    EMPLOYEE_INFORMATION_DESTINATION: true,

    // APPROVER_HIERARCHY
    APPROVER_HIERARCHY__FINANCIAL_APPROVERS: true,
    APPROVER_HIERARCHY__AMOUNT_THRESHOLDS: true,
    APPROVER_HIERARCHY__EMPLOYEE_TRANSACTION_APPROVERS: true,

    // Request_Approval
    REQUEST_APPROVAL__FINANCIAL_REQUESTS: true,
    REQUEST_APPROVAL__EMPLOYEE_TRANSACTION_REQUESTS: true,

    // Module
    CASH_ADVANCE_MODULE: false,
    SALARY_ADVANCE_MODULE: true,
    EMPLOYEE_TRANSACTION_MODULE: true,

    // OVERTIME
    ALLOW_OT_REQUEST_DATETIME : true,

    // Filter
    EMPLOYEE_FILTERS: ['VESSEL', 'EMPLOYEE_TYPE',],
    PAYROLL_EMPLOYEE_FILTERS: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION','DEPARTMENT', 'EMPLOYEE_TYPE', 'VESSEL',],
    // MAINTENANCE_SALARY_FILTERS: ['EMPLOYEE_TYPE', 'DEPARTMENT', 'POSITION', 'EFFECTIVE_DATE'],
    MAINTENANCE_SALARY_FILTERS: ['EMPLOYEE_TYPE', 'DEPARTMENT', 'POSITION'],
  },

  cvt: {
    ALLOW_FLEXITIME: true,
    EMPLOYEE_PERSONAL_EDITABLEEMPLOYEEID: true,
    EMPLOYEE_DAILY_SALARY_HAS_SALARY_BASIC: true,
  }
};